import { api } from "api";
import { useQuery } from "@tanstack/react-query";

/**
 * Client hook to obtain a link that can be used to make changes to a Stripe connected account.
 *
 * NOTE: This is a slightly weird case. The API call is a POST that runs a command, but we sort of want to treat it like
 * a query. As a result, we don't attempt to support cancellation via abort signal.
 * @returns React Query properties.
 */
export function useStripeSettingsFormLink() {
    return useQuery({
        queryKey: ["stripeSettingsFormLink"],
        queryFn: async () => await api.provider.stripeSettingsFormLink(),
        staleTime: 300000, // returned url expires after 5 minutes
        refetchInterval: 300000,
    });
}
